export function appendToUrlHash(text: string) {
  window.location.hash = text;
}
